import { PermissionsList } from '@modules/permissions/constants';
import { Permission } from '@modules/permissions/utils';

export const TRANSLATION_GROUP_AFFILIATE_PROGRAM_TRACKERS = Symbol('affiliate-program.trackers');

export const AFFILIATE_PROGRAM_TRACKERS_LIST_ROUTE_NAME = Symbol('affiliate-program.trackers.list');
export const AFFILIATE_PROGRAM_TRACKERS_FIXED_PAYMENTS_ROUTE_NAME = Symbol('affiliate-program.trackers.fixed-payment');
export const AFFILIATE_PROGRAM_TRACKERS_FIXED_PAYMENTS_HISTORY_EDIT_ROUTE_NAME = Symbol('affiliate-program.trackers.fixed-payment.history-edit');
export const AFFILIATE_PROGRAM_TRACKERS_DEAL_SETTINGS_MAIN_ROUTE_NAME = Symbol('affiliate-program.trackers.deal-settings');
export const AFFILIATE_PROGRAM_TRACKERS_DEAL_SETTINGS_HISTORY_CHANGES_EDIT_ROUTE_NAME = Symbol('affiliate-program.trackers.deal-settings.history-edit');

export const AFFILIATE_PROGRAM_TRACKERS_LIST_API_URL = 'admin/trackers/list';
export const AFFILIATE_PROGRAM_TRACKERS_LIST_REPORT_URL = 'admin/trackers/download_list';
export const AFFILIATE_PROGRAM_TRACKERS_LIST_QUERY_KEY = 'affiliate-program.trackers.list';
export const AFFILIATE_PROGRAM_TRACKERS_DOWNLOAD_LIST_MUTATION_KEY = 'affiliate-program.trackers.download-list';

export const AFFILIATE_PROGRAM_TRACKERS_PERMISSIONS = {
  SHOW: new Permission(PermissionsList.admin.TRACKERS_SHOW),
  DOWNLOAD_LIST: new Permission(PermissionsList.admin.TRACKERS_DOWNLOAD_LIST),
};
